<template>
  <!-- START OVERLAY -->
  <div class="overlay hide" data-pages="search">
    <!-- BEGIN Overlay Content !-->
    <div class="overlay-content has-results m-t-20">
      <!-- BEGIN Overlay Header !-->
      <div class="container-fluid">
        <!-- BEGIN Overlay Logo !-->
        <!-- END Overlay Logo !-->
        <!-- BEGIN Overlay Close !-->
        <a href="#" class="close-icon-light overlay-close text-black fs-16">
          <i class="pg-close"></i>
        </a>
        <!-- END Overlay Close !-->
      </div>
      <!-- END Overlay Header !-->
      <div class="container-fluid">
        <!-- BEGIN Overlay Controls !-->
        <input v-model="query" id="overlay-search" class="no-border overlay-search bg-transparent" placeholder="Search..." autocomplete="off" spellcheck="false">
        <br>
        <div class="inline-block">
          <div class="checkbox right">
            <input id="checkboxn" type="checkbox" value="1" checked="checked">
            <label for="checkboxn"><i class="fa fa-search"></i> Search within page</label>
          </div>
        </div>
        <div class="inline-block m-l-10">
          <p class="fs-13">Press enter to search</p>
        </div>
        <!-- END Overlay Controls !-->
      </div>
      <!-- BEGIN Overlay Search Results, This part is for demo purpose, you can add anything you like !-->
      <div class="container-fluid">
        <span>
              <strong>suggestions :</strong>
          </span>
        <span id="overlay-suggestions"></span>
        <br>
        <div class="search-results m-t-40">
          <p class="bold">Search Results</p>
          <div class="row">
            <div class="col-md-6" v-for="result in results">
              <!-- BEGIN Search Result Item !-->              
              <div class="search-result" v-if="result.type === 'item'">
                <!-- BEGIN Search Result Item Thumbnail !-->
                <div class="thumbnail-wrapper d48 text-white inline m-t-10">
                  <div>
                    <slot v-if="typeof result.item !== 'undefined' && Array.isArray(result.item.images) && result.item.images.length > 0">
                      <img width="50" height="50" :src="'/api/' + result.item.images[0].path" data-src="./assets/img/profiles/avatar.jpg" data-src-retina="./assets/img/profiles/avatar2x.jpg" alt="">
                    </slot>
                  </div>
                </div>
                <!-- END Search Result Item Thumbnail !-->
                <div class="p-l-10 inline p-t-5">
                  <h5 class="m-b-0"><span class="semi-bold result-name">{{ result.item.name }}</span></h5>
                  <span class="small">in <span class="semi-bold">products</span></span>
                </div>
              </div>
            </div>
              
            
          </div>
        </div>
      </div>
      <!-- END Overlay Search Results !-->
    </div>
    <!-- END Overlay Content !-->
  </div>
</template>

<script>
  export default {
    name: 'Search',
    data: () => ({
      query: '',
      results: []
    }),
    created() {
      this.$watch('query', (query) => {
        this.search(query);
      });
    },
    methods: {
      search(query) {
        this.results = [];
        this.$http
          .get('/items', { params: { page: 0, per_page: 10, query: query, order: 'name', dir: 'asc'} })
          .then((response) => {
            response.data.forEach((product) => {
              this.results.push({ type: 'item', item: product });
            });
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// search.vue?4b5c50f6